import { render, staticRenderFns } from "./trans-signup-info.html?vue&type=template&id=352e94d0&scoped=true&external"
import script from "./trans-signup-info.js?vue&type=script&lang=js&external"
export * from "./trans-signup-info.js?vue&type=script&lang=js&external"
import style0 from "./trans-signup-info.scss?vue&type=style&index=0&id=352e94d0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352e94d0",
  null
  
)

export default component.exports